import template from "./templates/item.jst";
import ItemView from "backdraft-app/src/listing/item";

import "shared/jquery/icon";

export default class AddListItem extends ItemView {
  get className() { return "row add-list__item"; }

  get attributes() {
    return {
      "data-element": "item"
    };
  }

  get events() {
    return {
      "click [data-action='remove-item']": "_handleRemove"
    };
  }

  render() {
    const readOnly = this.parent.options.readOnly;
    this.$el.html(template({ readOnly }));
    // eslint-disable-next-line new-cap
    const itemContent = new this.parent.options.itemContentView({ model: this.model, readOnly, listTemplateArgs: this.parent.options.listTemplateArgs });
    this.child('item-content', itemContent);
    this.$("[data-mount='item-content']").html(itemContent.render().$el);
    this.$el.icon();
    return this;
  }

  _handleRemove(e) {
    e.preventDefault();

    const parent = this.parent;

    this.closeItem();

    parent.trigger("item_removed");
    return false;
  }
}
